import React from 'react';
import ProductPage from 'components/page-product';
import Meta from 'shared/meta';

export default function ProductPageTemplate({ pageContext, location }) {
  return (
    <>
      <Meta
        title={`${pageContext?.title} | Cohort Clinical Sciences`}
        description={pageContext?.description}
        canonical={`https://store.cohortcs.com/product/${pageContext?.slug}/`}
      />
      <ProductPage {...pageContext} location={location} />
    </>
  );
}
